export const categories = [
  {
    id: 'trend',
    name: '趋势分析软件',
    icon: 'ri-line-chart-line',
    tagline: '读懂K线与趋势',
    description:
      '趋势分析软件通过技术指标、形态识别与智能预测，帮助投资者判断黄金价格的中短期方向，适合希望用数据辅助决策的分析型用户。',
    subCategories: ['技术指标', '形态识别', '智能预测'],
  },
  {
    id: 'price',
    name: '价格监控APP',
    icon: 'ri-radar-line',
    tagline: '实时盯盘到价提醒',
    description:
      '价格监控APP提供黄金、白银等贵金属的实时报价与到价提醒，多端同步不遗漏行情，适合需要随时掌握价格波动的上班族与短线关注者。',
    subCategories: ['实时盯盘', '到价提醒', '多端同步'],
  },
  {
    id: 'wealth',
    name: '理财工具',
    icon: 'ri-wallet-3-line',
    tagline: '定投测算与资产配置',
    description:
      '理财工具聚焦黄金定投、收益测算与资产配置规划，帮助用户用简单的方式管理黄金类资产，适合稳健型理财人群。',
    subCategories: ['定投计算', '收益测算', '资产配置'],
  },
  {
    id: 'news',
    name: '行情资讯',
    icon: 'ri-newspaper-line',
    tagline: '快讯研报财经日历',
    description:
      '行情资讯类应用聚合黄金市场快讯、机构研报与财经日历，帮助投资者快速了解影响金价的重要事件与市场情绪。',
    subCategories: ['实时快讯', '机构研报', '财经日历'],
  },
  {
    id: 'trade',
    name: '交易平台',
    icon: 'ri-exchange-dollar-line',
    tagline: '模拟交易到实盘',
    description:
      '交易平台提供模拟交易、实盘下单与风控管理功能，帮助用户在真实操作前熟悉黄金交易流程与风险管理。',
    subCategories: ['模拟交易', '实盘下单', '风控管理'],
  },
  {
    id: 'learn',
    name: '学习工具',
    icon: 'ri-book-open-line',
    tagline: '入门课程与实战',
    description:
      '学习工具提供黄金投资入门课程、名词词典与实战案例，帮助新手系统建立黄金投资的基础认知。',
    subCategories: ['入门课程', '名词词典', '实战案例'],
  },
];